// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".31a5126f55af5454e01dfc415969354a42dfb267.chunk.bundle.js";
};